import React, {
    PropTypes,
} from 'react';
import {Row, Col} from 'react-bootstrap';
import MenuView from './MenuView';
import {DateInput, CustomSelect} from '../../components';
import {DateChange, UserChange, LoadMenus, SaveOrder} from './actions';
import {connect} from 'react-redux';

class FoodView extends React.Component {
    static propTypes = {
        current: PropTypes.object.isRequired,
        users: PropTypes.array.isRequired,
        date: PropTypes.object.isRequired,
        DateChange: PropTypes.func.isRequired,
        UserChange: PropTypes.func.isRequired,
        LoadMenus: PropTypes.func.isRequired,
        SaveOrder: PropTypes.func.isRequired,
    };

    componentDidMount() {
        window.onbeforeunload = function (e) {
            e = e || window.event;
            const message = 'Вы дійсно бажаєте вийти без збереження?';
            if (e) {
                e.returnValue = message;
            }

            return message;
        };
    }

    componentWillUnmount() {
        window.onbeforeunload = null;
    }

    onUserChange(key) {
        const {users, UserChange, LoadMenus, date} = this.props;
        const user = users[key];

        UserChange(user.id, user.fio, user.type).then(() => LoadMenus(date, user));
    }

    onDateChange(date) {
        const {current, DateChange, LoadMenus} = this.props;

        DateChange(date).then(() => {
                if (current.id) {
                    LoadMenus(date, current);
                }
            }
        );
    }

    render() {
        const {current, users, date, SaveOrder, LoadMenus} = this.props;
        const userChoice = (
            <CustomSelect
                choices={users}
                current={current.id}
                idKey="id"
                emptyValue="Оберіть відвідувача"
                onChange={this.onUserChange.bind(this)}
                valueKey="fio"
                pic="user"
                className="mb10"
                avatar={(user) => user.photo ?
                    <img className="img-circle" alt={user.fio} width={16}
                         src={"data:image/gif;base64," + user.photo}/> : ''}
            />
        );
        const onDateChange = this.onDateChange.bind(this);
        const dateChoice = (
            <DateInput date={date} onDateChange={onDateChange}/>
        );
        return (
            <div>
                <h3 className="mt5 mb15 text-uppercase" style={{fontWeight: "bold"}}>Замовлення харчування</h3>
                <Row>
                    <Col lg={8} md={12}>
                        <Row>
                            <Col md={6}>{userChoice}</Col>
                            <Col md={6}>{dateChoice}</Col>
                        </Row>
                        <MenuView isLoaded={false}
                                  onSave={(saleTimes, menus, description) => SaveOrder(
                                      saleTimes, menus, current.id, current.type, date, description
                                  )}
                                  onReload={() => LoadMenus(date, current)}/>
                    </Col>
                </Row>
            </div>
        );
    };
}

function mapStateToProps(state) {
    const objects = state.food.objects;
    return {
        users: objects,
        current: state.food.currentUser,
        date: state.food.date,
    };
}

export default connect(mapStateToProps, {DateChange, UserChange, LoadMenus, SaveOrder})(FoodView);




/** WEBPACK FOOTER **
 ** ./src/modules/food/FoodView.js
 **/